import { render, staticRenderFns } from "./RiskRatingOverridePopup.vue?vue&type=template&id=a549b202"
import script from "./RiskRatingOverridePopup.vue?vue&type=script&lang=js"
export * from "./RiskRatingOverridePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports